<template>
    <div class="container teaser-image">
        <div class="row">
            <div class="col-md-7">
                <a class="teaser-image__link teaser-image__link--item-4-3 teaser-image__link--item-5-4" target="blank" :href="items['item-1']['link']">
                    <div class="teaser-image__text teaser-image__text--top teaser-image__text-mobile--top teaser-image__text--pos teaser-image__text-mobile--pos">
                        <p class="teaser-image__tagline" v-html="items['item-1']['tagline']"></p>
                        <h3 class="teaser-image__title"  v-html="items['item-1']['title']"></h3>
                    </div>
                    <img class="img-fluid teaser-image__image d-none d-md-block" :src="baseUrl + items['item-1']['desktop']['image']['url']"  :alt="items['item-1']['desktop']['image']['alt']">
                    <img class="img-fluid teaser-image__image d-block d-md-none" :src="baseUrl + items['item-1']['mobile']['image']['url']" :alt="items['item-1']['mobile']['image']['alt']">
                </a>
            </div>
            <div class="col-md-5">
                <a class="teaser-image__link teaser-image__link--item-4-4 teaser-image__link--item-5-5" @click="openTeaser(items['item-2']['title'], items['item-2']['content'])">
                    <div class="teaser-image__text teaser-image__text--bottom teaser-image__text-mobile--bottom teaser-image__text--pos teaser-image__text-mobile--pos">
                        <p class="teaser-image__tagline" v-html="items['item-2']['tagline']"></p>
                        <h3 class="teaser-image__title"  v-html="items['item-2']['title']"></h3>
                    </div>
                    <img class="img-fluid teaser-image__image d-none d-md-block" :src="baseUrl + items['item-2']['desktop']['image']['url']" :alt="items['item-2']['desktop']['image']['alt']">
                    <img class="img-fluid teaser-image__image d-block d-md-none" :src="baseUrl + items['item-2']['mobile']['image']['url']" :alt="items['item-2']['mobile']['image']['alt']">
                </a>
            </div>
            <div class="col-md-5 teaser-image__margin-desktop">
                <a  @click="openTeaser(items['item-3']['title'])" target="blank" class="teaser-image__link teaser-image__link teaser-image__link--item-3-1" :href="items['item-3']['link']">
                    <div class="teaser-image__text  teaser-image__text--top teaser-image__text-mobile--top teaser-image__text--neg teaser-image__text-mobile--neg">
                        <p class="teaser-image__tagline" v-html="items['item-3']['tagline']"></p>
                        <h3 class="teaser-image__title"  v-html="items['item-3']['title']"></h3>
                    </div>
                    <img class="img-fluid teaser-image__image d-none d-md-block" :src="baseUrl + items['item-3']['desktop']['image']['url']" :alt="items['item-3']['desktop']['image']['alt']">
                    <img class="img-fluid teaser-image__image d-block d-md-none" :src="baseUrl + items['item-3']['mobile']['image']['url']" :alt="items['item-3']['mobile']['image']['alt']">
                </a></div>
            <div class="col-md-7 teaser-image__margin-desktop">
                <a @click="openTeaser(items['item-4']['title'])" target="blank" class="teaser-image__link teaser-image__link teaser-image__link--item-3-3" :href="items['item-4']['link']">
                    <div class="teaser-image__text teaser-image__text--top teaser-image__text-mobile--top teaser-image__text--neg teaser-image__text-mobile--neg">
                        <p class="teaser-image__tagline" v-html="items['item-4']['tagline']"></p>
                        <h3 class="teaser-image__title"  v-html="items['item-4']['title']"></h3>
                    </div>
                    <img class="img-fluid teaser-image__image d-none d-md-block" :src="baseUrl + items['item-4']['desktop']['image']['url']" :alt="items['item-4']['desktop']['image']['alt']">
                    <img class="img-fluid teaser-image__image d-block d-md-none" :src="baseUrl + items['item-4']['mobile']['image']['url']" :alt="items['item-4']['mobile']['image']['alt']">
                </a>
                <a @click="openTeaser(items['item-5']['title'])" target="blank" class="teaser-image__link teaser-image__link--item-3-2" :href="items['item-5']['link']">
                    <div class="teaser-image__text teaser-image__text--bottom teaser-image__text-mobile--bottom teaser-image__text--neg teaser-image__text-mobile--neg">
                        <p class="teaser-image__tagline" v-html="items['item-5']['tagline']"></p>
                        <h3 class="teaser-image__title"  v-html="items['item-5']['title']"></h3>
                    </div>
                    <img class="img-fluid teaser-image__image d-none d-md-block" :src="baseUrl + items['item-5']['desktop']['image']['url']" :alt="items['item-5']['desktop']['image']['alt']">
                    <img class="img-fluid teaser-image__image d-block d-md-none" :src="baseUrl + items['item-5']['mobile']['image']['url']" :alt="items['item-5']['mobile']['image']['alt']">
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'
    import analytics from '../mixins/analytics-tracking'

    export default {
        mixins: [analytics],
        props: ["items"],
        methods: {
            ...mapActions([
                'openOverlay',
                'closeOverlay',
                'resetAll'
            ]),
            openTeaser(title, content = undefined) {
                this.trackTeaser(title);
                if (content) {
                  this.openOverlay(content);
                }
            }
        },
        computed: {
            ...mapGetters([
                'overlayOpen',
                'priceState',
                'animationFinished'
            ]),
            baseUrl() {
                return process.env.BASE_URL
            }
        },
        mounted() {
            window.onpopstate = () => {
                if(this.overlayOpen) {
                    this.closeOverlay();
                } else if(this.animationFinished && this.$config.default.PRICE_MAP[this.priceState]) {
                    this.resetAll();
                }
            }
        }
    }
</script>
<style lang="scss">
    .teaser-image {
        &__link {
            cursor: pointer
        }

        &__margin-desktop {
            .teaser-image {
                &__link--item-3-1,
                &__link--item-3-2 {
                    @media (min-width: 768px) {
                        margin-top: 20px;
                    }
                }
            }
        }
    }
</style>
